import { getWithExpiry } from "../utils/storage"
import { BASE_DOMAIN, STAGING_BASE_DOMAIN } from "./env"



export const create_event_rsvp = async (params) => {
  var url = `${BASE_DOMAIN}/api/method/community.v1.event_management.create_event_rsvp`

  try{
    var response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(params)
    })        
    return response
  } catch(error) {
    throw error
  }   
}

export const request_rsvp_otp = async (params) => {
  var url = `${BASE_DOMAIN}/api/method/community.v1.event_management.initiate_rsvp_auth`

  if (params) {
    const queryParams = new URLSearchParams(params).toString();
    url += `?${queryParams}`;
  }

  console.log('url', url);
  

  try{
    var response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }
    })        
    return response
  } catch(error) {
    throw error
  }   
}

export const verify_rsvp_otp = async (params) => {
  var url = `${BASE_DOMAIN}/api/method/community.v1.event_management.verify_rsvp_otp`

  // if (params) {
  //   const queryParams = new URLSearchParams(params).toString();
  //   url += `?${queryParams}`;
  // }

  // console.log('url', url);
  

  try{
    var response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(params)
    })        
    return response
  } catch(error) {
    throw error
  }   
}

export const fetch_event = async (params) => {
  

  try{
    var url = `${BASE_DOMAIN}/api/method/community.v1.event_management.fetch_event`
    if (params) {
      const queryParams = new URLSearchParams(params).toString();
      url += `?${queryParams}`;
    }

    var response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })        
    return response
  } catch(error) {
    throw error
  }   
}

export const get_event_rsvp = async (params) => {
  try{
    var url = `${BASE_DOMAIN}/api/method/community.v1.event_management.get_event_rsvp`
    if (params) {
      const queryParams = new URLSearchParams(params).toString();
      url += `?${queryParams}`;
    }    
    console.log('get_event_rsvp url', url);
    
    var response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })        
    return response
  } catch(error) {
    throw error
  }   
}

export const update_event_rsvp = async (params) => {
  try{
    var url = `${BASE_DOMAIN}/api/method/community.v1.event_management.update_event_rsvp`
    if (params) {
      const queryParams = new URLSearchParams(params).toString();
      url += `?${queryParams}`;
    }    
    console.log('update_event_rsvp url', url);
    
    var response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })        
    return response
  } catch(error) {
    throw error
  }   
}